import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { IRootStoreProps, WithoutStore, withStore } from '../../../stores';
import { ChatBlock } from '../components';

class _Chat extends Component<IRootStoreProps> {
  render() {
    return <ChatBlock />;
  }
}

export const ChatPage: WithoutStore = withStore(observer(_Chat));
